import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Tag, Spin, TimePicker, message } from "antd";
import moment from "moment";
import { usrRole } from "../../utils/dataUtil";
import { formateDate } from "../../utils/dateUtil";
import {
  req_signle_pim_staff_one_day,
  req_edit_pim_staff_overtime_new,
} from "../../api";
import { LoadingOutlined } from "@ant-design/icons";
class DayBunchLogModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    data: PropTypes.object.isRequired,
  };

  state = {
    userLevel: "NORMAL",
    data: [],
    item: {},
    loading: false,
    antiShake: false,
    setStartTime: "17:30",
    setEndTime: "21:30",
  };

  componentDidMount() {
    this.api_item_list();
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_item_list = async () => {
    const { token, role } = this.props.user;
    const { StaffCode, ApplyDate } = this.props.data;
    //console.log(this.props.data);
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel, loading: true });
    const result = await req_signle_pim_staff_one_day(
      userLevel,
      StaffCode,
      ApplyDate,
      token,
    );
    if (result.total > 0) {
      const items = result.data;
      const antiShake = items[0].BunchTimeFirst !== null;
      this.setState({ data: items, loading: false, item: items[0], antiShake });
      console.log(items[0]);
    } else {
      const items = [];
      this.setState({
        data: items,
        loading: false,
        item: {},
      });
    }
  };

  api_edit_item_overtime = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_pim_staff_overtime_new(item, token);
    if (result.status === "success") {
      message.success("修正加班時間成功");
    } else {
      message.error("修正加班時間失敗");
    }
  };

  /////////////////////////////////////////////
  onStartTimeChange = (time, timeString) => {
    this.setState({ setStartTime: timeString });
  };

  onEndTimeChange = (time, timeString) => {
    this.setState({ setEndTime: timeString });
  };

  handle_ok_process = () => {
    const { ApplyDate } = this.props.data;
    const { setStartTime, setEndTime } = this.state;
    const { ClockDate } = this.state.item;
    console.log("item", this.state.item);

    // 直接組合 ISO 格式字串
    const isoStartTimeString =
      ClockDate !== undefined
        ? `${ClockDate.slice(0, 4)}-${ClockDate.slice(
            4,
            6,
          )}-${ClockDate.slice(6, 8)}T${setStartTime}`
        : `${ApplyDate.slice(0, 4)}-${ApplyDate.slice(
            4,
            6,
          )}-${ApplyDate.slice(6, 8)}T${setStartTime}`;
    const isoEndTimeString =  ClockDate !== undefined
        ? `${ClockDate.slice(0, 4)}-${ClockDate.slice(
      4,
      6,
    )}-${ClockDate.slice(6, 8)}T${setEndTime}`
        : `${ApplyDate.slice(0, 4)}-${ApplyDate.slice(
            4,
            6,
          )}-${ApplyDate.slice(6, 8)}T${setEndTime}`;

    // 轉換為日期物件
    const startdateTime = new Date(isoStartTimeString);
    const enddateTime = new Date(isoEndTimeString);
    const row = {
      StaffCode:  ClockDate !== undefined ? this.state.item.StaffCode : this.props.data.StaffCode,
      OvertimeDate: ClockDate !== undefined ? ClockDate : ApplyDate,
      OvertimeClockStart: startdateTime,
      OvertimeClockEnd: enddateTime,
      condition: "FIX_OVERTIME",
    };
    console.log(row);
    this.api_edit_item_overtime(row);
  };

  render() {
    const { loading, data, userLevel } = this.state;
    const antIcon = (
      <LoadingOutlined
        style={{
          fontSize: 24,
        }}
        spin
      />
    );
    return (
      <Card>
        {loading ? (
          <div>
            <Spin indicator={antIcon} />
            <span style={{ marginLeft: "5px" }}>查核中...</span>
          </div>
        ) : (
          <>
            <p>
              <span>職工姓名：</span>
              <span>{data.length > 0 ? data[0].StaffName : "無紀錄"}</span>
            </p>
            <p>
              <span>身分別：</span>
              <span>
                {data.length > 0 ? (
                  data[0].Insurance === "公保" ? (
                    <Tag color="purple">{data[0].Insurance}</Tag>
                  ) : (
                    <Tag color="red">{data[0].Insurance}</Tag>
                  )
                ) : (
                  "無紀錄"
                )}
              </span>
            </p>
            <div>
              <p>
                <span>作息起始時間：</span>
                <span style={{ color: "gray" }}>
                  {data.length > 0
                    ? formateDate(data[0].ClockInTimeMustReal)
                    : "無紀錄"}
                </span>
              </p>
              <p>
                <span>作息結束時間：</span>
                <span style={{ color: "gray" }}>
                  {data.length > 0
                    ? formateDate(data[0].ClockOutTimeMustReal)
                    : "無紀錄"}
                </span>
              </p>
            </div>
            <p>
              <span>實際簽到時間：</span>
              <span style={{ color: "blue" }}>
                {data.length > 0
                  ? formateDate(data[0].BunchTimeFirst)
                  : "無紀錄"}
              </span>
            </p>
            <p>
              <span>實際簽退時間：</span>
              <span style={{ color: "blue" }}>
                {data.length > 0
                  ? formateDate(data[0].BunchTimeLast)
                  : "無紀錄"}
              </span>
            </p>
            <p>
              <span>備註：</span>
              <span style={{ color: "red" }}>
                {data.length > 0 ? (
                  data[0].takeLeaveTimeEnd !== null ? (
                    <p>
                      當日請假時間
                      <br />
                      {formateDate(data[0].takeLeaveTimeStart)}
                      <br />
                      {formateDate(data[0].takeLeaveTimeEnd)}
                    </p>
                  ) : (
                    ""
                  )
                ) : (
                  ""
                )}
              </span>
            </p>
            {userLevel === "POFFICEA" ? (
              <div
                style={{
                  marginTop: "10px",
                  backgroundColor: "#f5f5f5",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                起：
                <TimePicker
                  defaultValue={moment("17:30", "HH:mm")}
                  onChange={this.onStartTimeChange}
                  format={"HH:mm"}
                />
                <br />
                訖：
                <TimePicker
                  defaultValue={moment("21:30", "HH:mm")}
                  onChange={this.onEndTimeChange}
                  format={"HH:mm"}
                />
                <button
                  type="button"
                  className="btn btn-warning btn-sm"
                  style={{ marginTop: "4px", width: "100%" }}
                  onClick={this.handle_ok_process}
                >
                  變更加班申請起訖時間
                </button>
              </div>
            ) : (
              ""
            )}
          </>
        )}
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(DayBunchLogModal);
